import AboutUs from "../components/AboutUs";
import ClubWonders from "../components/ClubWonders";
import ContactUs from "../components/ContactUs";
import Footer from "../components/Footer";
import TopBanner from "../components/TopBanner";
import RevealOnScroll from "../components/RevealOnScroll";

const Home = () => {
  return (
    <div className="relative min-h-screen bg-club-background flex flex-col">
      <TopBanner />
      <div className="flex flex-col justify-center gap-6 md:gap-12 px-4 md:px-24 lg:px-36">
        <RevealOnScroll>
          <ClubWonders />
        </RevealOnScroll>
        <RevealOnScroll>
          <AboutUs />
        </RevealOnScroll>
        <RevealOnScroll>
          <ContactUs />
        </RevealOnScroll>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
